/**
 * vendor が新 DB (2 フェーズ取込 / parquet 正) に載っているか (is_new_db)。
 *
 * true = 2 フェーズ取込 (4 段ダイアログ + v3 API) / false = 従来の 2 段 (legacy)。
 * 値の源はサーバ由来フラグ (`loginUser.client.is_new_db`) で、use-auth が loginUser 取得時に
 * `platform_url` と並べて `setIsNewDb()` で流し込む。React ツリー内は `useLoginUser()` の
 * `proto.isNewDb` を直接使えばよいが、gateway 層は React コンテキスト外なので、この
 * モジュール singleton から `getIsNewDb()` で読む (querybar/dashboard の URL 版切替用)。
 *
 * 既定は false (フラグ未設定/未返却 = 従来動作)。
 */
let newDb = false;

/** use-auth が loginUser 取得時 (と logout 時) に呼ぶ。 */
export function setIsNewDb(value: boolean): void {
  newDb = value;
}

/** gateway 層など React 外からモードを読む。true = 新 DB (v3/新エンドポイント)。 */
export function getIsNewDb(): boolean {
  return newDb;
}
